import React, { FC, useRef } from "react";
import type { InvestorExampleProps } from "@/types";
import { ContentManager } from "../content-manager";
import Image from "next/image";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const InvestorExample: FC<InvestorExampleProps> = ({ content }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="investorExample">
      <div className="wrapper wrapper_lg" ref={ref}>
        <div
          className="investorExample--inner"
          style={{
            transform: isInView ? "none" : `translateY(20px)`,
            opacity: isInView ? 1 : 0,
            transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
          }}
        >
          <SplitTextAnimation
            htmlElement={
              <ContentManager
                content={content}
                className="investorExample--content"
                style={{
                  transform: isInView ? "none" : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                }}
              />
            }
            isInView={isInView}
          />
          <Image
            src="/images/spiral-2.webp"
            alt="Spiral"
            width={1288}
            height={1582}
            draggable={false}
            className="investorExample--bg"
          />
        </div>
      </div>
    </section>
  );
};
